import { createRouter as createVueRouter, createWebHistory } from 'vue-router';

import routes from './routes';
import { beforeResolveRoute, requireAuth } from './utils/router.util';

export const createRouter = () => {
    const router = createVueRouter({
        history: createWebHistory(),
        routes,
    });

    router.beforeEach((to) => requireAuth(to));
    router.beforeResolve((to, from, next) => {
        return beforeResolveRoute(to, from, next);
    });

    return router;
};
